import { useMemo } from 'react';

import {
  CHESS_RUSSIAN_CLUB_ID,
  PER_EVENT_TICKET,
  PER_EVENT_COUNTER,
  LINK_TOURNAMENTS,
  GRAND_PRIX_PROMO_PAGE,
  GRAND_PRIX_PROMO_PAGE_PRICES,
  SUBSCRIPTION_TICKET,
} from '@features/chessrussian/customizations/constants';
import { findUserTicket } from '@features/chessrussian/customizations/utils/user-tickets';
import { useMyTicketsQuery } from '@features/shared/api/user';

import { PremiumSubscription } from './PremiumSubscription';

export function PremiumSubscriptionWidget({ className }: { className?: string }) {
  const { data } = useMyTicketsQuery();

  const subscription = useMemo(
    () => findUserTicket(data, CHESS_RUSSIAN_CLUB_ID, SUBSCRIPTION_TICKET),
    [data],
  );

  const tournamentsTicket = useMemo(
    () => findUserTicket(data, CHESS_RUSSIAN_CLUB_ID, PER_EVENT_TICKET),
    [data],
  );

  return (
    <>
      {subscription && (
        <PremiumSubscription
          className={className}
          loading={!data}
          timestampEnd={subscription.notAfterTimestampMs}
          tournamentsLeft={null}
          linkInfo={GRAND_PRIX_PROMO_PAGE}
          linkEvents={LINK_TOURNAMENTS}
          linkPrices={GRAND_PRIX_PROMO_PAGE_PRICES}
        />
      )}
      {tournamentsTicket && (
        <PremiumSubscription
          className={className}
          loading={!data}
          timestampEnd={tournamentsTicket.notAfterTimestampMs}
          tournamentsLeft={tournamentsTicket.counters?.[PER_EVENT_COUNTER]}
          isAdditional={Boolean(subscription)}
          linkInfo={GRAND_PRIX_PROMO_PAGE}
          linkEvents={LINK_TOURNAMENTS}
          linkPrices={GRAND_PRIX_PROMO_PAGE_PRICES}
        />
      )}
      {!subscription && !tournamentsTicket && (
        <PremiumSubscription
          className={className}
          loading={!data}
          linkInfo={GRAND_PRIX_PROMO_PAGE}
          linkEvents={LINK_TOURNAMENTS}
          linkPrices={GRAND_PRIX_PROMO_PAGE_PRICES}
        />
      )}
    </>
  );
}
